module.exports = {"id":"189946","name":"Vincent Manceau","rating":"73","photo":"./data/images/photos/4/189946.png","club":{"name":"Angers SCO","logo":"./data/images/clubs/AngersSCO.png"},"positions":["DD","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VincentManceau0.json
// module id = 4280
// module chunks = 0